import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';
import CCPAForm from '../CCPAForm';

const Footer = () => {
  const [showCCPAForm, setShowCCPAForm] = useState(false);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__content">
          <div className="footer__section">
            <h3 className="footer__title">Company</h3>
            <ul className="footer__list">
              {/* Hidden temporarily
              <li className="footer__item">
                <Link to="/about" className="footer__link">
                  About
                </Link>
              </li>
              */}
              <li className="footer__item">
                <Link to="/case-studies" className="footer__link">
                  Case Studies
                </Link>
              </li>
              <li className="footer__item">
                <Link to="/contact-us" className="footer__link">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer__section">
            <h3 className="footer__title">Legal and Compliance</h3>
            <ul className="footer__list">
              <li className="footer__item">
                <Link to="/privacy-policy" className="footer__link">
                  Privacy Policy
                </Link>
              </li>
              {/* Hidden temporarily
              <li className="footer__item">
                <Link to="/terms-conditions" className="footer__link">
                  Terms & Conditions
                </Link>
              </li>
              */}
              <li className="footer__item">
                <button
                  onClick={() => setShowCCPAForm(true)}
                  className="footer__link footer__link--button"
                >
                  Do Not Sell My Personal Information
                </button>
              </li>
            </ul>
          </div>

          <div className="footer__section">
            <h3 className="footer__title">About</h3>
            <p className="footer__text">
              DevSecOps, Inc. specializes in cloud security, GRC programs, and scalable solutions to
              secure and optimize your business in the cloud
            </p>
            <div className="footer__social">
              {/* Temporarily hidden
              <a
                href="https://facebook.com"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="social-icon facebook"></i>
              </a>
              */}
              <a
                href="https://x.com/devsecopsinc"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="social-icon twitter"></i>
              </a>
              {/* Temporarily hidden
              <a
                href="https://instagram.com"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="social-icon instagram"></i>
              </a>
              */}
              <a
                href="https://www.youtube.com/@devsecopsinc"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="social-icon youtube"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">DevSecOps, Inc. (c) 2025. All rights reserved.</p>
        </div>
      </div>
      {showCCPAForm && <CCPAForm onClose={() => setShowCCPAForm(false)} />}
    </footer>
  );
};

export default Footer;
